import styled from "styled-components";
import { CenteredFlex } from "../../../components/layout";
import { Widget } from "../../../components/widget";
import { device } from "../../../styles/media";

export const HeaderContainer = styled(({ startAlpha, endAlpha, ...props }) => (
  <Widget {...props} />
))<{
  degree: number;
  end: string;
  endAlpha: number;
  start: string;
  startAlpha: number;
  colour: string;
}>`
  ${CenteredFlex};
  flex-direction: column;
  text-align: center;
  margin-bottom: 1em;
  background: linear-gradient(
    ${(props) => props.degree}deg,
    ${(props) => props.start} ${(props) => props.startAlpha}%,
    ${(props) => props.end} ${(props) => props.endAlpha}%
  );
  color: ${(props) => props.colour};
`;

export const LaunchLogo = styled.img`
  max-width: 75%;

  @media ${device.laptop} {
    max-width: 270px;
  }
`;
